import { useMemo } from "react";

import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";
import { useAllPlans } from "routes/data-routes/billing-data/plans";
import { usePlanHelpers } from "routes/data-routes/billing-data/plans/usePlanHelpers";


export function useNextHigherPlan() {
  const { activeSubscription, activeSubscriptionFetcher } = useActiveSubscription();
  const { allPlansFetcher } = useAllPlans();
  const { getUpgradeTarget } = usePlanHelpers();

  const isLoading = (activeSubscriptionFetcher.state === "loading") || (allPlansFetcher.state === "loading");

  const nextPlan = useMemo(() => getUpgradeTarget(activeSubscription?.planSlug), [ activeSubscription?.planSlug, getUpgradeTarget ]);

  return {
    nextHigherPlan: nextPlan,
    isLoading
  };
}
